import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import PlusDoorIcon from '../svgicons/PlusDoorIcon'
import * as DoorAccessActionCreators from '../../actions/doorAccess'
import Pluralize from '../controls/Pluralize'
import TooltipIconButton from '../controls/TooltipIconButton'

class GrantDoorAccessButtonContainer extends React.Component {
  static propTypes = {
    /* passed props */
    accessIds: PropTypes.array.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps() {
    return {}
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  handleClick = () => {
    this.props.doorAccessActions.setGrantDoorAccessUserIds(this.props.accessIds)
  }

  render() {
    const userCount = this.props.accessIds.length
    const tooltipTitle = (
      <span>
        Add Door Access
        { (userCount > 1)
          && <span><br />for <Pluralize count={userCount} singular="User" /></span>}
      </span>
    )

    return (
      <TooltipIconButton
        color="primary"
        onClick={this.handleClick}
        tooltipTitle={tooltipTitle}
      >
        <PlusDoorIcon />
      </TooltipIconButton>
    )
  }
}

export default connect(
  GrantDoorAccessButtonContainer.mapStateToProps,
  GrantDoorAccessButtonContainer.mapDispatchToProps,
)(GrantDoorAccessButtonContainer)
